import { formatToLocaleUSD } from 'helper/short-currency';

export const getMetaData = (
  stageName: string,
  amount: number,
  clientName: string,
  businessName: string,
) => [
  {
    type: 'amount',
    label: 'Deal value',
    value: formatToLocaleUSD(amount || 0),
  },
  { type: 'avatar', label: 'Client name', value: clientName || '' },
  { type: 'business', label: 'Company', value: businessName || '' },
  {
    type: 'select',
    label: 'Stage',
    value: stageName,
  },
  { type: 'text', label: 'Docusign', value: 'None' },
  { type: 'actions' },
];
